import React from 'react';

import { Typography } from '@mui/material';
import { CommunityHero } from 'src/components/icons/CommunityHero';
import { useSelectedCommunityCategory } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  header: {
    backgroundColor: 'rgb(40,58,66)',
    position: 'relative',
    width: '100%',
  },
  heroSubText: {
    color: theme.palette.common.white,
  },
  heroText: {
    color: theme.palette.common.white,
    fontSize: 44,
    fontWeight: 800,
  },
  heroTextContainer: {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%) translateX(-50%)',
    width: '75%',
  },
  heroTitle: {
    color: '#CB3E6D',
    fontWeight: 600,
  },
}));

export function CommunityPageHeader(): JSX.Element {
  const { classes } = useStyles();

  return (
    <>
      <header className={classes.header}>
        <CommunityHero />
        <div className={classes.heroTextContainer}>
          <Typography align="center" className={classes.heroTitle}>
            ALINE COMMUNITY
          </Typography>
          <CommunityHeaderText />
        </div>
      </header>
    </>
  );
}

function CommunityHeaderText(): JSX.Element {
  const { classes } = useStyles();
  const { selectedCategory } = useSelectedCommunityCategory();

  if (!selectedCategory)
    return (
      <Typography align="center" className={classes.heroText}>
        Explore The Fastest Growing Library of Legal Templates
      </Typography>
    );

  return (
    <>
      <Typography align="center" className={classes.heroText}>
        {`${selectedCategory.emoji.trim()} ${selectedCategory.title.trim()}`}
      </Typography>
      <Typography align="center" className={classes.heroSubText}>
        {selectedCategory.description}
      </Typography>
    </>
  );
}
